import React, { Component } from 'react';
import {
  Text,
  View,
  Dimensions,
  Modal
} from 'react-native-web';
import constants from '../global-constants.jsx';
import FreqFinder from '../frequency-finder.jsx';

export default class Snake extends Component {

  startClock() {
    this.clock = setInterval(this.moveSnake.bind(this), 1000);
    this.clock_going = true;
  }
  stopClock() {
    clearInterval(this.clock);
    this.clock_going = false;
  }

  constructor(props) {
    super(props);
    this.old_note = "none";
    this.clock = null;
    this.clock_going = false;
    this.grid_width = 9;
    this.grid_height = 15;
    this.state = {
      result: "none",
      snakeLocations: [[4, 7]],
      appleLocation: this.pickNewAppleLocation([[4, 7]]),
      snakeDirection: "down",
      messageModalVisible: false,
      gameMessage: "YOU!"
    }
    this.tile_width = Dimensions.get("window").width / this.grid_width;
    this.tile_height = (Dimensions.get("window").height - 66) / this.grid_height;
  }

  componentDidMount() {
    this.initializeFreqFinder();
  }

  componentWillUnmount() {
    console.log("unmounting");
    constants.freqfinder.stop();
  }

  initializeFreqFinder() {
    constants.freqfinder = new FreqFinder();
    this.setControlsScheme(this.normalOperation);
    constants.freqfinder.start();
  }

  setControlsScheme(controlStructure) {
    constants.freqfinder.action = (note) => {
      if (note !== this.old_note) {
        let newState = this.state;
        if (note === "none") {
          controlStructure.bind(this)(newState);
        }
        this.old_note = note;
        newState.result = note;
        this.setState(newState);
      }
    }
  }

  normalOperation(newState) {
    if (this.old_note === "special") {
      if (newState.messageModalVisible) {
        newState.messageModalVisible = false;
        newState.snakeLocations = [[4, 7]];
        newState.appleLocation = this.pickNewAppleLocation([[4, 7]]);
        this.stopClock();
        return;
      }
      if (newState.snakeDirection !== "right") {
        newState.snakeDirection = "left";
      }
    }
    else if (this.old_note === "special2") {
      if (newState.messageModalVisible) {
        newState.messageModalVisible = false;
        newState.snakeLocations = [[4, 7]];
        newState.appleLocation = this.pickNewAppleLocation([[4, 7]]);
        this.stopClock();
        return;
      }
      if (newState.snakeDirection !== "right") {
        newState.snakeDirection = "left";
      }
    }
    else if (this.old_note === "up" && newState.snakeDirection !== "down") {
      newState.snakeDirection = "up";
    }
    else if (this.old_note === "down" && newState.snakeDirection !== "up") {
      newState.snakeDirection = "down";
    }
    else if (this.old_note === "left" && newState.snakeDirection !== "right") {
      newState.snakeDirection = "left";
    }
    else if (this.old_note === "right" && newState.snakeDirection !== "left") {
      newState.snakeDirection = "right";
    }
    if (this.clock_going === false) {
      this.startClock();
    }
  }

  compareLocations(x1, x2) { return (x1[0] === x2[0] && x1[1] === x2[1]) }

  pickNewAppleLocation(snake) {
    let grid = Array(this.grid_width).fill().map(() => Array(this.grid_height).fill(true));
    snake.forEach((location) => { grid[location[0]][location[1]] = false });
    let availableSpots = [];
    for (let i = 0; i < this.grid_width; i++) {
      for (let j = 0; j < this.grid_height; j++) {
        if (grid[i][j]) {
          availableSpots.push([i, j]);
        }
      }
    }
    return availableSpots[Math.floor(Math.random() * availableSpots.length)];
  }

  endGame(message) {
    let newState = this.state;
    newState.gameMessage = message;
    newState.messageModalVisible = true;
    this.setState(newState);
  }

  moveSnake() {
    let newState = this.state;
    let direction = this.state.snakeDirection;
    let delta = [0, 0];
    if (direction === "up") {
      delta = [0, -1];
    } else if (direction === "down") {
      delta = [0, 1];
    } else if (direction === "left") {
      delta = [-1, 0];
    } else if (direction === "right") {
      delta = [1, 0];
    }
    console.log(delta);
    let snakeHead = this.state.snakeLocations[0];
    let snake = this.state.snakeLocations;
    let newHead = [snakeHead[0] + delta[0], snakeHead[1] + delta[1]];
    let apple = this.state.appleLocation;

    console.log(newHead)
    // Check if the snake went out of bounds.
    if (newHead[0] < 0 || newHead[0] >= this.grid_width ||
      newHead[1] < 0 || newHead[1] >= this.grid_height) {
      this.endGame("YOU LOSE!");
      return;
    }
    // Check if snake is eating itself.
    for (let i = 0; i < snake.length; i++) {
      if (this.compareLocations(newHead, snake[i])) {
        this.endGame("YOU LOSE!");
        return;
      }
    }
    // Check if the snake landed on the apple.
    if (this.compareLocations(newHead, apple)) {
      if (snake.length === this.grid_width * this.grid_height - 1) {
        this.endGame("YOU WIN!");
        return;
      }
      snake.unshift(newHead);
      newState.snakeLocations = snake
      newState.appleLocation = this.pickNewAppleLocation(snake);
    } else {
      console.log(snake);
      snake.pop();
      snake.unshift(newHead);
      console.log(snake);
      newState.snakeLocations = snake;
    }

    this.setState(newState);
  }


  render() {

    let colors = ["powderblue", "skyblue"];
    let columns = [];
    let grid = Array(this.grid_width).fill().map(() => Array(this.grid_height).fill(0));

    this.state.snakeLocations.forEach((location) => {
      grid[location[0]][location[1]] = 1;
    });

    grid[this.state.appleLocation[0]][this.state.appleLocation[1]] = 2;

    for (let i = 0; i < this.grid_width; i++) {
      let column = [];
      for (let j = 0; j < this.grid_height; j++) {
        let background_color = colors[(i + j) % 2];
        if (grid[i][j] === 1) { background_color = "red"; }
        if (grid[i][j] === 2) { background_color = "green"; }
        column.push(<View style={{
          width: this.tile_width,
          height: this.tile_height,
          backgroundColor: background_color
        }}
          key={(i * this.grid_width + j).toString()}
        >
        </View>)
      }
      columns.push(
        <View key={(i + 100).toString()}>
          {column}
        </View>
      );
    }


    return (
      <View style={{ flex: 1 }}>

        <Text>{this.state.result}</Text>
        <View style={{ flex: 1, flexDirection: 'row' }}>
          {columns}
        </View>
        <Modal
          animationType="slide"
          transparent={false}
          visible={this.state.messageModalVisible}
        >
          <View style={{ flex: 1, justifyContent: "center" }}>
            <View
              style={{ flexDirection: "row", justifyContent: "center" }}
              onClick={() => {
                let newState = this.state;
                newState.messageModalVisible = false;
                newState.snakeLocations = [[4, 7]];
                newState.appleLocation = this.pickNewAppleLocation([[4, 7]]);
                this.stopClock();
                this.setState(newState);
              }}
            >
              <Text>
                {this.state.gameMessage}
              </Text>
            </View>
          </View>
        </Modal>

      </View>);
  }
}
